import React from 'react';
import styled from 'styled-components';
import Arrow from '@catalogo/ui-americanas-desktop-svg/arrow.svg';
import { withProductQuantity } from '@catalogo/service-americanas-product/src/hocs/product-quantity';

export const SelectorQuantity = props => {
  const { productQty, history, limit } = props;

  return (
    <Container onClick={openModal(history, limit)}>
      quantidade:&nbsp;
      <b>
        {productQty} unidade{productQty > 1 && 's'}
      </b>
      &nbsp;
      <NavigateArrow fill="#666" width="12px" height="12px" />
    </Container>
  );
};

export function openModal(history, limit) {
  const { pathname, search } = history.location;
  return () => history.replace({ pathname, search, hash: '#modal-select-qty', state: { limit } });
}

const Container = styled.p`
  text-align: center;
  margin: 18px 0;
`;

const NavigateArrow = styled(Arrow)`
  cursor: pointer;
`;

export default withProductQuantity(SelectorQuantity);
